import { Link } from "react-router-dom";
import CategoryTag from "@/components/base/CategoryTag";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  item: NewsItem;
  variant?: "default" | "wide";
}

export default function NewsCard({ item, variant = "default" }: NewsCardProps) {
  const isWide = variant === "wide";

  return (
    <Link
      to={`/detail/${item.id}`}
      className={`group flex ${isWide ? "flex-col md:flex-row" : "flex-col"} bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer`}
    >
      <div
        className={`overflow-hidden bg-background-200 shrink-0 ${
          isWide ? "md:w-72 w-full aspect-[16/10] md:aspect-auto md:h-auto" : "w-full aspect-[16/10]"
        }`}
      >
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 森泽佳奈资讯`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4 md:p-5 flex flex-col flex-1">
        <div className="flex items-center gap-2 mb-3 flex-wrap">
          <CategoryTag label={item.category} tone={item.category === "活动公告" ? "accent" : "primary"} />
          <span className="text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {item.date}
          </span>
        </div>
        <h3
          className={`font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug ${
            isWide ? "text-lg md:text-xl" : "text-base md:text-lg"
          }`}
        >
          {item.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed mt-2 line-clamp-3 flex-1">
          {item.summary}
        </p>
        <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 mt-4 group-hover:gap-2 transition-all">
          阅读详情
          <i className="ri-arrow-right-line"></i>
        </span>
      </div>
    </Link>
  );
}